////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
import { isEmpty } from 'lodash'
///////COMPONENTS///////
import TableNested from '../../../components/Table/components/TableNested'
import ValueCheck from '../../../helpers/ValueCheck'

//////STYLED//////
const ScheduledPromoManagerNestedWrapper = styled.td`
	display: ${(props) => (props.isVisible ? 'table-cell' : 'none')};
	border-top: 1px solid ${(props) => props.theme.colors.table.borderTable};
	& > div {
		max-width: calc(100vw - 350px);
		position: sticky;
		left: 100px;
		min-width: max-content;
	}
	& > div:before {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		left: -1px;
		box-shadow: 3px 0px 3px #00000029;
		z-index: 20;
		top: 0px;
	}
	& > div:after {
		content: '';
		height: 100%;
		width: 1px;
		position: absolute;
		right: -1px;
		box-shadow: -3px 0px 3px #00000029;
		z-index: 20;
		top: 0px;
	}
	& > div > div {
		min-width: max-content;
	}
`
//////STYLED//////

const ScheduledPromoManagerNested = (props) => {
	const { row } = props

	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const config = {
		isInNestedTable: true,
	}
	const currency = props.row.currency.symbol

	const columns = [
		{
			dataHook: 'kioskCode',
			headerName: translations['page__promotionManagement__tableHeader_expand_kioskCode'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'store',
			headerName: translations['page__promotionManagement__tableHeader_expand_store'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'itemFamily.translationKey',
			headerName: translations['page__promotionManagement__tableHeader_expand_family'],
			sortable: true,
			isAuthorize: true,
			toTranslate: true,
		},
		{
			dataHook: 'itemBrand.label',
			headerName: translations['page__promotionManagement__tableHeader_expand_brand'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'label',
			headerName: translations['page__promotionManagement__tableHeader_expand_product'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'standardPrice',
			headerName: translations['page__promotionManagement__tableHeader_expand_itemPrice'],
			sortable: true,
			isAuthorize: true,
			component: (_props) => ValueCheck.ValueCheck(_props?.row?.standardPrice, '-', currency),
		},
		{
			dataHook: 'depositPrice',
			headerName: translations['page__promotionManagement__tableHeader_expand_depositPrice'],
			sortable: true,
			isAuthorize: true,
			component: (_props) => ValueCheck.ValueCheck(_props?.row?.depositPrice, '-', currency),
		},
	]

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ScheduledPromoManagerNestedWrapper colSpan={props.colspan} isVisible={props.stateToggleNested}>
			<div>
				<div>
					{!isEmpty(row.promotionItemLines) && (
						<TableNested inputColumns={columns} inputData={props.row.promotionItemLines} inputConfig={config} />
					)}
				</div>
			</div>
		</ScheduledPromoManagerNestedWrapper>
	)
}

ScheduledPromoManagerNested.propTypes = {}

ScheduledPromoManagerNested.defaultPropTypes = {}

export default ScheduledPromoManagerNested
